import React from 'react';
import { ScanLine } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-slate-900 text-slate-400 py-12 border-t border-slate-800" data-id="element-801">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-802">
        <div className="grid md:grid-cols-4 gap-8 mb-12" data-id="element-803">
          <div className="col-span-1 md:col-span-2" data-id="element-804">
            <Link to="/" className="flex items-center space-x-2 mb-4 group" data-id="element-805">
              <img src="https://cdn.magicpatterns.com/uploads/kYypn9DLGTyuEjc1d2cJka/intellieats_icon.webp" alt="IntelliEats icon" className="h-8 w-8 rounded-lg shadow-lg group-hover:shadow-brand-500/20 transition-all duration-300" data-id="element-806" />
              <span className="text-xl font-bold text-white tracking-tight" data-id="element-807">
                Intelli<span className="text-brand-500" data-id="element-808">Eats</span>
              </span>
            </Link>
            <p className="text-sm max-w-xs leading-relaxed" data-id="element-809">
              Empowering you to make healthier food choices through intelligent
              ingredient analysis. Scan, detect, and eat smarter.
            </p>
          </div>

          <div data-id="element-810">
            <h3 className="text-white font-bold mb-4" data-id="element-811">Product</h3>
            <ul className="space-y-2 text-sm" data-id="element-812">
              <li data-id="element-813">
                <a href="/#how-it-works" className="hover:text-brand-400 transition-colors" data-id="element-814">
                  How It Works
                </a>
              </li>
              <li data-id="element-815">
                <a href="/#features" className="hover:text-brand-400 transition-colors" data-id="element-816">
                  Features
                </a>
              </li>
              <li data-id="element-817">
                <Link to="/blog" className="hover:text-brand-400 transition-colors" data-id="element-818">
                  Blog
                </Link>
              </li>
              <li data-id="element-819">
                <a href="/#download" className="hover:text-brand-400 transition-colors" data-id="element-820">
                  Download
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-821">
            <h3 className="text-white font-bold mb-4" data-id="element-822">Legal</h3>
            <ul className="space-y-2 text-sm" data-id="element-823">
              <li data-id="element-824">
                <Link to="/privacy" className="hover:text-brand-400 transition-colors" data-id="element-825">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-826">
                <Link to="/terms" className="hover:text-brand-400 transition-colors" data-id="element-827">
                  Terms of Service
                </Link>
              </li>
              <li data-id="element-828">
                <Link to="/editorial-policy" className="hover:text-brand-400 transition-colors" data-id="element-829">
                  Editorial Policy
                </Link>
              </li>
              <li data-id="element-830">
                <Link to="/contact" className="hover:text-brand-400 transition-colors" data-id="element-831">
                  Contact Support
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center text-sm" data-id="element-832">
          <p data-id="element-833">© {new Date().getFullYear()} IntelliEats. All rights reserved.</p>
          <p className="mt-2 md:mt-0" data-id="element-834">Developed by Nidhi Matele</p>
        </div>
      </div>
    </footer>;
}